import { useState } from 'react';
import * as bd from 'react-basic-design';
import { Tab } from 'react-bootstrap';
import { T } from '../../components/basic/text';
import { PageNavbar } from '../../components/ui/page-navbar';
import { TProvider } from '../../i18n';
import { RoleTeams } from './role-teams';
import { Users } from './users';

export const ManageAccessApp = ({ selectedTab }: { selectedTab?: string }) => {
    const tabs = ['users', 'role-teams'];
    const defaultTab = selectedTab || 'role-teams';
    const [visitedTabs, setVisitedTabs] = useState<string[]>([defaultTab]);
    const isVisited = (t: string) => visitedTabs.indexOf(t) >= 0;
    const visitTab = (t: string) => !isVisited(t) && setVisitedTabs([...visitedTabs, t]);

    return (
        <TProvider>
            <div className="container-fluid px-2 px-sm-2 px-lg-4">
                <PageNavbar onGoBack="/home" title="manage-users-and-access-roles" />

                <bd.Paper className="border">
                    <Tab.Container defaultActiveKey={defaultTab}>
                        <bd.TabStrip className="container-fluid standard-tabstrip">
                            {tabs.map(t => (
                                <bd.TabStripItem key={t} eventKey={t} onClick={() => visitTab(t)}>
                                    <T>{t}</T>
                                </bd.TabStripItem>
                            ))}
                        </bd.TabStrip>

                        <Tab.Content>
                            {isVisited('users') && (
                                <Tab.Pane eventKey="users">
                                    <Users />
                                </Tab.Pane>
                            )}
                            {isVisited('role-teams') && (
                                <Tab.Pane eventKey="role-teams">
                                    <RoleTeams />
                                </Tab.Pane>
                            )}
                        </Tab.Content>
                    </Tab.Container>
                </bd.Paper>
            </div>
        </TProvider>
    );
};
